//Import
import React from "react";
import styled from "styled-components";
import styles from "./Modal_styles";
import { Table } from "antd";
//Components
import ModalContainer from "../ModalContainer";
import ModalCentered from "../ModalCentered";
import ModalHeader from "../ModalHeader";
import ModalContent from "../ModalContent";
import ModalFooter from "../ModalFooter";
import FormInput from "../FormInput/FormInput";
import ModalBottom from "../ModalBottom";
import ModalCronograma from "../ModalCronograma";

// External components
import { Tabs } from "antd";
import { formatNumber } from "../../helpers/formatNumber";
import ErrorInput from "../ErrorInput/ErrorInput";
import {formatDate} from "../../helpers/formatDate";
const callback = (key) => {};

/**
 *
 * Props:
 * type:String = Show modaltype 2 Options. "centered" "bottom"
 * show:Boolean = Modal Visibility
 * w:String = Modal width in css values
 * opacity:String / Number = Layout opacity values 0 to 1, 0.5 by default
 */

// Componente base
const Modal_base = ({
  dataModal,
  dataModalDetalle,
  closeModal,
  closeModalDetalle,
  handleInputChange,
  handleInputBlur,
  errorsForm,
  closeModalCliente,
  handleCrearClienteSubmit,
  show,
  type,
  w,
  opacity,
  dataModalDetalleAbonos,
  dataModalDetalleCuotas,
  ...props
}) => {
  //Modal type centered
  const modalCentered = () => {
    return (
      <ModalContainer>
        <ModalCentered w={w}>
          <form onSubmit={handleCrearClienteSubmit}>
            <ModalHeader closeModal={closeModalCliente} icon="">
              {" "}
              Crear Cliente Nuevo{" "}
            </ModalHeader>
            <ModalContent>
              <FormInput
                name="documentoIdentificacion"
                formlabel="Documento de Identificación"
                handleInputChange={handleInputChange}
                handleInputBlur={handleInputBlur}
                type="number"
              ></FormInput>
              {errorsForm.documentoIdentificacion && (
                <ErrorInput textoError={errorsForm.documentoIdentificacion} />
              )}
              <FormInput
                name="nombreCompleto"
                formlabel="Nombre Completo"
                handleInputChange={handleInputChange}
                handleInputBlur={handleInputBlur}
                type="text"
              ></FormInput>
              {errorsForm.nombreCompleto && (
                <ErrorInput textoError={errorsForm.nombreCompleto} />
              )}
              <FormInput
                name="direccion"
                formlabel="Dirección"
                handleInputChange={handleInputChange}
                handleInputBlur={handleInputBlur}
                type="text"
              ></FormInput>
              {errorsForm.direccion && (
                <ErrorInput textoError={errorsForm.direccion} />
              )}
              <FormInput
                name="barrio"
                formlabel="Barrio"
                handleInputChange={handleInputChange}
                handleInputBlur={handleInputBlur}
                type="text"
              ></FormInput>
              {errorsForm.barrio && (
                <ErrorInput textoError={errorsForm.barrio} />
              )}
              <FormInput
                name="celular"
                formlabel="Celular"
                handleInputChange={handleInputChange}
                handleInputBlur={handleInputBlur}
                type="number"
              ></FormInput>
              {errorsForm.celular && (
                <ErrorInput textoError={errorsForm.celular} />
              )}
            </ModalContent>
            <ModalFooter closeModal={closeModalCliente}></ModalFooter>
          </form>
        </ModalCentered>
      </ModalContainer>
    );
  };

  //Modal type bottom
  const modalBottom = () => {
    const colmuns = [
      {
        title: "Valor",
        dataIndex: "monto_total",
        render: (valor_abono) => formatNumber(valor_abono),
      },
      {
        title: "Saldo",
        dataIndex: "saldo_pendiente",
        render: (saldo) => formatNumber(saldo),
      },
        {
        title: "M. Pago",
        dataIndex: "metodo_pago",
      },
      {
        title: "Fecha",
        dataIndex: "created_at",
        render: (fecha) => formatDate(fecha),
      },
    ];

    // El cronograma se muestra únicamente si dataModalDetalleCuotas trae
    // información (no depende de la forma de pago del crédito).
    const mostrarCronograma =
      dataModalDetalleCuotas !== "" &&
      Array.isArray(dataModalDetalleCuotas?.cuotas) &&
      dataModalDetalleCuotas.cuotas.length > 0;

    const items = [
      {
        key: "1",
        label: "Pago",
        children:
            dataModalDetalleAbonos !== "" ? (
                <Table
                    columns={colmuns}
                    dataSource={dataModalDetalleAbonos.abonos || []}
                    pagination={false}
                    rowKey="id"
                />
            ) : null,
      },
      {
        key: "2",
        label: "Info General",
        children:
            dataModalDetalle !== "" ? (
                <>
                  <p>
                    <strong>Fecha Creación:</strong>{" "}
                    {formatDate(dataModalDetalle.created_at)}
                  </p>
                  <p>
                    <strong>Valor: </strong>{" "}
                    {formatNumber(dataModalDetalle.monto_principal)}
                  </p>
                  <p>
                    <strong>Seguro: </strong>{" "}
                    {formatNumber(dataModalDetalle.seguro)}
                  </p>
                  <p>
                    <strong>Saldo:</strong>{" "}
                    {formatNumber(dataModalDetalle.saldo_pendiente)}
                  </p>
                  <p>
                    <strong>Valor Cuota: </strong>{" "}
                    {formatNumber(dataModalDetalle.valor_cuota)}
                  </p>
                  <p>
                    <strong>Cuotas Pactadas: </strong>
                    {dataModalDetalle.numero_cuotas}
                  </p>
                    <p>
                        <strong>Forma Pago: </strong>
                        {dataModalDetalle.forma_pago?.nombre}
                    </p>
                  <p>
                    <strong>Utilidad: </strong>{" "}
                    {dataModalDetalle.interes_porcentaje} %
                  </p>
                  <p>
                    <strong>Calificación: </strong>
                    {dataModalDetalle.cliente?.calificacion}
                  </p>
                  <p>
                    <strong>Dirección: </strong>
                    {dataModalDetalle.cliente?.direccion}
                  </p>
                  <p>
                    <strong>Teléfono: </strong>
                    {dataModalDetalle.cliente?.celular_1}
                  </p>
                  <p>
                    <strong>Documento: </strong>
                    {dataModalDetalle.cliente?.documento_identificacion}
                  </p>
                  <p>
                    <strong>Producto: </strong>
                    {dataModalDetalle.producto}
                  </p>
                  <p>
                    <strong>Descripción: </strong>
                    {dataModalDetalle.descripcion}
                  </p>
                </>
            ) : null,
      },
    ];

    if (mostrarCronograma) {
      items.unshift({
        key: "0",
        label: "Cronograma",
        children: (
          <ModalCronograma
            dataModalDetalle={dataModalDetalle}
            dataModalDetalleAbonos={dataModalDetalleAbonos}
            dataModalDetalleCuotas={dataModalDetalleCuotas}
          />
        ),
      });
    }

    return (
      <ModalBottom>
        <ModalHeader icon="" noclose closeModalDetalle={closeModalDetalle}>
          {" "}
          {dataModalDetalle !== ""
            ? dataModalDetalle.cliente.nombre_completo
            : ""}{" "}
        </ModalHeader>
        <ModalContent>
          <Tabs
              key={`${show}-${dataModalDetalle !== "" ? dataModalDetalle?.id : "sin-credito"}-${mostrarCronograma}`}
              defaultActiveKey={mostrarCronograma ? "0" : "1"}
              onChange={callback}
              className="ow-tabs"
              items={items}
          />
        </ModalContent>
      </ModalBottom>
    );
  };

  // Render
  return (
    <div {...props}>
      {type === "centered"
        ? modalCentered()
        : type === "bottom"
        ? modalBottom()
        : "No Modal rendered"}
    </div>
  );
};
const Modal = styled(Modal_base)`
  ${styles}
`;
export default Modal;
